import { ChallengePresenter } from '@/presentation/presenters/problem/challengePresenter'
import { ChallengeViewModel } from '@/presentation/viewmodels/problem/challengeViewModel'

export function useChallengePresenter(
  presenter: ChallengePresenter = new ChallengePresenter(new ChallengeViewModel())
) {
  return {
    largeClassificationList: presenter.largeClassificationList,
    middleClassificationList: presenter.middleClassificationList,
    contestList: presenter.contestList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    getChallengeList: presenter.getChallengeList.bind(presenter),
    getChallengeById: presenter.getChallengeById.bind(presenter)
  }
}
